import styled from "styled-components";
import { colors } from "../../../../theme/color";
import { ToggleBaseNo, ToggleBaseYes } from "../../../../../public/assets";
import { useEffect, useState } from "react";
import { useQuery, useMutation } from "@apollo/client";
import {
  getAllPermissions,
  getRolePermissions,
} from "../../../../graphql/queries/userManagement";
import {
  assignPermission,
  removeRolePermission,
} from "../../../../graphql/mutations/userManagement";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";

const PermisionBody = styled.div`
  padding: 0px 15px 0px 0px;
`;

const PermissionTitleHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 40%;
  padding: 30px 0px 30px 10px;
`;

const PermissionTitle = styled.span`
  font-size: 14px;
  font-weight: 400px;
  color: ${colors.NEUTRAL_NEUTRAL};
  cursor: pointer;
`;

const PermissionSubText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.NEUTRAL_NEUTRAL};
  width: 80%;
  line-height: 24px;
`;

const PermissionContent1 = styled.div`
  width: 97%;
  border-bottom: 1px solid #e8eaed;
  padding: 25px 0px;
  display: flex;
  font-size: 14px;
  font-weight: 400;

  @media screen and (max-width: 430px) {
    flex-direction: column;
    width: 90%;
  }

  @media screen and (max-width: 390px) {
    flex-direction: column;
    width: 90%;
  }
`;

const PermissionContent3 = styled.div`
  width: 97%;
  border-bottom: 1px solid #e8eaed;
  padding: 25px 0px;
  display: flex;
  font-size: 14px;
  font-weight: 400;
  color: ${colors.NEUTRAL_NEUTRAL};

  @media screen and (max-width: 430px) {
    flex-direction: column;
    width: 90%;
  }

  @media screen and (max-width: 390px) {
    flex-direction: column;
    width: 90%;
  }
`;

const PermissionContent2 = styled.div`
  padding-bottom: 70px;
  padding-top: 25px;
  font-size: 14px;
  font-weight: 400;

  @media screen and (max-width: 430px) {
    flex-direction: column;
    width: 90%;
  }

  @media screen and (max-width: 390px) {
    flex-direction: column;
    width: 90%;
  }
`;

const PermissionViewUser = styled.div`
  width: 35%;
  display: flex;
  align-items: center;
  margin: 0 aut0;
  color: ${colors.BLACK};

  @media screen and (max-width: 430px) {
    width: 100%;
    margin-bottom: 10px;
  }

  @media screen and (max-width: 390px) {
    width: 100%;
    margin-bottom: 10px;
  }
`;

const PermissionViewUserB = styled.div`
  width: 55%;
  display: flex;
  align-items: center;
  padding-left: 20px;
  color: #868686;

  @media screen and (max-width: 430px) {
    width: 100%;
    padding-left: 0;
  }

  @media screen and (max-width: 390px) {
    width: 100%;
    padding-left: 2px;
  }
`;

const PermissionViewUserC = styled.div`
  width: 55%;
  display: flex;
  align-items: center;
  padding-left: 20px;
  color: ${colors.NEUTRAL_NEUTRAL};

  @media screen and (max-width: 430px) {
    width: 100%;
    padding-left: 0;
  }

  @media screen and (max-width: 390px) {
    width: 100%;
    padding-left: 2px;
  }
`;

const ViewUserSpan = styled.span`
  text-align: center;
  display: flex;
  flex-direction: flex-start;
  width: 70%;
`;

const AddModifyUser = styled.span`
  width: 70%;
  text-align: center;

  @media screen and (max-width: 430px) {
    display: flex;
    justify-content: flex-start;
  }

  @media screen and (max-width: 390px) {
    display: flex;
    justify-content: flex-start;
  }
`;

const PermissionViewRoles = styled.div`
  width: 35%;
  display: flex;
  align-items: center;
  margin: 0 aut0;

  @media screen and (max-width: 430px) {
    width: 100%;
    margin-bottom: 10px;
  }

  @media screen and (max-width: 390px) {
    width: 100%;
    margin-bottom: 10px;
  }
`;

const PermissionImgCon = styled.div`
  display: flex;
  width: 20%;
`;

const PermissionImgSpan = styled.span`
  text-align: center;
  padding-left: 10px;
`;
export interface Permissions {
  name?: string;
  type?: string;
  id?: string;
  permissionId?: string;
  roleId?: string;
}
const Administrator = () => {
  const { loading, data, refetch: refetchUsers } = useQuery(getAllPermissions);
  const permissions: Permissions[] = data?.getAllPermissions.data || [];
  const { organization_role_id } = useSelector(
    (state: RootState) => state.user?.user
  );
  const { data: rolePermissionsData, refetch: refetchRolePermissions } =
    useQuery(getRolePermissions, {
      variables: { roleId: organization_role_id },
    });
  const [removePermissionMutation] = useMutation(removeRolePermission);
  const [assignPermissionMutation] = useMutation(assignPermission);

  type ToggleKeys = string;

  const [toggles, setToggles] = useState<Record<ToggleKeys, boolean>>({
    "View Users": false,
    "Add/Modify Users": false,
    "View Roles Admin": false,
    "Add/Modify Roles": false,
    "View Cards Admin": false,
  });
  const [permissionMap, setPermissionMap] = useState<Record<string, string>>({
    "View Users": "",
    "Add/Modify Users": "",
    "View Roles Admin": "",
    "Add/Modify Roles": "",
    "View Cards Admin": "",
  });

  useEffect(() => {
    if (permissions.length) {
      const map: Record<string, string> = {};
      permissions.forEach((perm) => {
        if (typeof perm.name === "string") {
          map[perm.name] = perm.id || "";
        }
      });
      setPermissionMap(map);
    }
  }, [permissions]);

  useEffect(() => {
    if (rolePermissionsData) {
      const rolePermissions = rolePermissionsData.rolePermissions;

      const newToggles = {
        "View Users": hasPermissionWithId(
          rolePermissions,
          permissionMap["View Users"]
        ),
        "Add/Modify Users": hasPermissionWithId(
          rolePermissions,
          permissionMap["Add/Modify Users"]
        ),
        "View Roles Admin": hasPermissionWithId(
          rolePermissions,
          permissionMap["View Roles Admin"]
        ),
        "Add/Modify Roles": hasPermissionWithId(
          rolePermissions,
          permissionMap["Add/Modify Roles"]
        ),
        "View Cards Admin": hasPermissionWithId(
          rolePermissions,
          permissionMap["View Cards Admin"]
        ),
      };
      setToggles(newToggles);
    }
  }, [rolePermissionsData, permissionMap]);

  const hasPermissionWithId = (
    permissions: { permissionId: string }[] | undefined,
    id: string | undefined
  ): boolean => {
    return (
      !!id &&
      Array.isArray(permissions) &&
      permissions.some((perm) => perm.permissionId === id)
    );
  };

  const handleToggle = async (key: ToggleKeys) => {
    try {
      const permissionId = permissionMap[key];
      if (!permissionId) {
        console.error(`Permission ID not found for key: ${key}`);
        return;
      }
      const newToggleValue = !toggles[key];
      setToggles((prevToggles) => ({
        ...prevToggles,
        [key]: newToggleValue,
      }));

      if (newToggleValue) {
        const response = await assignPermissionMutation({
          variables: {
            roleId: organization_role_id,
            permissionId: permissionId,
          },
        });
        setToggles((prevToggles) => ({
          ...prevToggles,
          [key]: response.data.assignRolePermission,
        }));
      } else {
        const response = await removePermissionMutation({
          variables: {
            roleId: organization_role_id,
            permissionId: permissionId,
          },
        });
        setToggles((prevToggles) => ({
          ...prevToggles,
          [key]: !response.data.removeRolePermission,
        }));
      }
      refetchRolePermissions();
    } catch (error) {
      console.error("Error updating permission:", error);
    }
  };

  return (
    <div style={{ width: "77vw", paddingLeft: "20px" }}>
      <PermisionBody>
        <div>
          <PermissionContent1>
            <PermissionViewUser>
              <ViewUserSpan>1. View Users</ViewUserSpan>
              <PermissionImgCon onClick={() => handleToggle("View Users")}>
                <img
                  src={`/assets/svg/ToggleBase${toggles["View Users"] ? "Yes" : "No"}.svg`}
                  alt=""
                />
                <PermissionImgSpan>
                  {toggles["View Users"] ? "Yes" : "No"}
                </PermissionImgSpan>
              </PermissionImgCon>
            </PermissionViewUser>
            <PermissionViewUserB>
              <AddModifyUser>1.1 Add/Modify Users</AddModifyUser>
              <PermissionImgCon
                onClick={() => handleToggle("Add/Modify Users")}
              >
                <img
                  src={`/assets/svg/ToggleBase${toggles["Add/Modify Users"] ? "Yes" : "No"}.svg`}
                  alt=""
                />
                <PermissionImgSpan>
                  {toggles["Add/Modify Users"] ? "Yes" : "No"}
                </PermissionImgSpan>
              </PermissionImgCon>
            </PermissionViewUserB>
          </PermissionContent1>

          <PermissionContent3>
            <PermissionViewRoles>
              <ViewUserSpan>2. View Roles</ViewUserSpan>
              <PermissionImgCon
                onClick={() => handleToggle("View Roles Admin")}
              >
                <img
                  src={`/assets/svg/ToggleBase${toggles["View Roles Admin"] ? "Yes" : "No"}.svg`}
                  alt=""
                />
                <PermissionImgSpan>
                  {toggles["View Roles Admin"] ? "Yes" : "No"}
                </PermissionImgSpan>
              </PermissionImgCon>
            </PermissionViewRoles>
            <PermissionViewUserC>
              <AddModifyUser>2.2 Add/Modify Roles</AddModifyUser>
              <PermissionImgCon
                onClick={() => handleToggle("Add/Modify Roles")}
              >
                <img
                  src={`/assets/svg/ToggleBase${toggles["Add/Modify Roles"] ? "Yes" : "No"}.svg`}
                  alt=""
                />
                <PermissionImgSpan>
                  {toggles["Add/Modify Roles"] ? "Yes" : "No"}
                </PermissionImgSpan>
              </PermissionImgCon>
            </PermissionViewUserC>
          </PermissionContent3>

          <PermissionContent1>
            <PermissionViewUser>
              <ViewUserSpan>3. View Cards </ViewUserSpan>
              <PermissionImgCon
                onClick={() => handleToggle("View Cards Admin")}
              >
                <img
                  src={`/assets/svg/ToggleBase${toggles["View Cards Admin"] ? "Yes" : "No"}.svg`}
                  alt=""
                />
                <PermissionImgSpan>
                  {toggles["View Cards Admin"] ? "Yes" : "No"}
                </PermissionImgSpan>
              </PermissionImgCon>
            </PermissionViewUser>
          </PermissionContent1>

          {/* <PermissionContent2>
            <PermissionViewUser>
              <ViewUserSpan>4. View Roles</ViewUserSpan>
              <PermissionImgCon
                onClick={() => handleToggle("anotherViewRoles")}
              >
                <img
                  src={`/assets/svg/ToggleBase${toggles.viewRoles ? "Yes" : "No"}.svg`}
                  alt=""
                />
                <PermissionImgSpan>
                  {toggles.anotherViewRoles ? "Yes" : "No"}
                </PermissionImgSpan>
              </PermissionImgCon>
            </PermissionViewUser>
          </PermissionContent2> */}
        </div>
      </PermisionBody>
    </div>
  );
};

export default Administrator;
